<template>
  <span class="bc-pill"
        :class="'--' + tone">
    <i v-if="icon"
       :class="icon"></i>{{ label }}
  </span>
</template>

<script>
// Status of one broadcast. `status` is the API's (draft | sending | paused | done | cancelled);
// a pause the seller did not ask for (pausedReason other than "seller") is หยุดอัตโนมัติ.
export default {
  name: "BcStatusPill",
  props: {
    status: { type: String, default: "" },
    pausedReason: { type: String, default: null },
  },
  computed: {
    key() {
      if (this.status === "sending") return "sending";
      if (this.status === "paused") return this.pausedReason && this.pausedReason !== "seller" ? "autopause" : "paused";
      if (this.status === "cancelled") return "cancelled";
      return "done";
    },
    tone() {
      return { sending: "info", paused: "warning", autopause: "danger", cancelled: "muted", done: "success" }[this.key];
    },
    icon() {
      return {
        sending: "fal fa-paper-plane",
        paused: "fal fa-clock",
        autopause: "fal fa-exclamation-triangle",
        cancelled: "",
        done: "fas fa-check",
      }[this.key];
    },
    label() {
      return this.$t("broadcast.screens.status." + this.key);
    },
  },
};
</script>

<style lang="scss" scoped>
.bc-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.15rem 0.7rem;
  border-radius: 999px;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.5;
  white-space: nowrap;

  &.--success {
    background: rgba(48, 196, 76, 0.15);
    color: #1a6e2e;
  }

  &.--info {
    background: rgba(39, 170, 224, 0.15);
    color: #1d6f94;
  }

  &.--warning {
    background: rgba(255, 152, 0, 0.15);
    color: #9a5a00;
  }

  &.--danger {
    background: rgba(246, 116, 116, 0.18);
    color: #c62828;
  }

  &.--muted {
    background: rgba(158, 158, 158, 0.18);
    color: #666;
  }
}

body.--dark {
  .bc-pill {
    &.--success {
      color: #8fe3a0;
    }

    &.--info {
      color: #8cd6f5;
    }

    &.--warning {
      color: #ffd98a;
    }

    &.--danger {
      color: #ff9d9d;
    }

    &.--muted {
      color: #c4c4c4;
    }
  }
}
</style>

